import Vue from "vue";
//Spinner de chargement
import Loading from "vue-loading-overlay";

//Definition du spinner de chargement
Vue.use(Loading);

/**
 * Classe utilitaire pour le controle de l'affichage du chargement
 *
 */
const loadingService = {
  //Entité du loader
  loader: {},
  //Définit si le loader est en cours
  isOn: false,
  //Permet de compter le nombre de loader en cours
  loaderCount: 0,
  /**
   * Affiche le loader, attention l'activation du loader ne peut être fait qu'une fois au risque qu'il soit bloqué allumé, d'ou l'utilisation des variables loaderCount et isOn
   */
  showLoading() {
    //On compte le nombre d'appel pour maintenir le loader activé
    loadingService.loaderCount++;
    //Si un loader est en cours on ne relance pas de loader
    if (!loadingService.isOn) {
      //le loader ne peut etre redéfini qu'une fois au risque de perdre la référence et de ne pas pouvoir l'arréter
      loadingService.loader = Vue.prototype.$loading.show();
      loadingService.isOn = true;
    }
  },
  /**
   * Désactive le loader prend en compte l'utilisation de plusieurs loader.
   */
  hideLoading() {
    loadingService.loaderCount--;

    //Pour arreter le loader il faut qu'un loader soit en cours et le nombre d'appel de showLoading et hideLoading soit identique(loaderCompte == 0)
    if (loadingService.isOn && loadingService.loaderCount == 0) {
      loadingService.loader.hide();
      loadingService.isOn = false;
    }
  },
};

export default loadingService;
